import { dashboard } from 'types';
import { toJSONArray } from '../../../../packages/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  apiKeys: dashboard.TockApiKey[];
}

const initialState: State = {
  apiKeys: [],
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.FETCH_TOCK_API_KEY_DONE: {
      return { apiKeys: toJSONArray<dashboard.TockApiKey>(payload) };
    }
    default:
      return state;
  }
}
